export default __webpack_public_path__ + "static/Plain-Thin-d4ccc2fc2211c0138eb8e002687bab90.woff";